module.exports = __webpack_public_path__ + "static/media/Chiller_On_img.2b7b2ffa.gif";